var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPxHandbrakeIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "79px",
    height: "66px",
    viewBox: "0 0 79 66",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "px-handbrake-illustration") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "11.0315406%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A45B8A",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4154E4",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "11.0315406%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A45B8A",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4154E4",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "11.0315406%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A45B8A",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4154E4",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AD6C96",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AD6C96",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "6.-Accident-flow-\\u2013-EG-fleet",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "10j.-Handbrake-is-released-\\u2013-Rewe-\\u2013--No-damage",
    transform: "translate(-147.000000, -424.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "::-Body",
    transform: "translate(0.000000, 332.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "px-handbrake-illustration",
    transform: "translate(147.000000, 92.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.8124037,14 L54,14.3185986 L39.7467308,33.7513499 C39.5886948,33.9385092 39.5924776,34.210444 39.7556609,34.3933073 L46.5437101,42 L23.0443237,41.9056548 C20.2829222,41.8945683 18.0533513,39.6470228 18.0644378,36.8856213 C18.071682,35.0812517 19.0505465,33.4207558 20.625768,32.540711 L53.8124037,14 L53.8124037,14 Z",
    id: "Rectangle",
    fillOpacity: 0.2,
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.0964983,37.9660347 C68.5147763,37.9660347 72.0964983,41.5477567 72.0964983,45.9660347 L72.0964983,53 C72.0964983,54.1045695 71.2010678,55 70.0964983,55 L4,55 C2.8954305,55 2,54.1045695 2,53 L2,45.9660347 C2,41.5477567 5.581722,37.9660347 10,37.9660347 L64.0964983,37.9660347 Z M64.0909841,41.9740265 L10.0055142,41.9740265 C7.79637519,41.9740265 6.00551419,43.7648875 6.00551419,45.9740265 L6.00551419,45.9740265 L6.00551419,50.4920082 C6.00551419,50.7681505 6.22937181,50.9920082 6.50551419,50.9920082 L6.50551419,50.9920082 L67.5909841,50.9920082 C67.8671265,50.9920082 68.0909841,50.7681505 68.0909841,50.4920082 L68.0909841,50.4920082 L68.0909841,45.9740265 C68.0909841,43.7648875 66.3001231,41.9740265 64.0909841,41.9740265 L64.0909841,41.9740265 Z",
    id: "Combined-Shape",
    fillOpacity: 0.9,
    fill: "url(#linearGradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.0771986,43.9700306 L58.0771986,48.4880123 C58.0771986,48.7641546 57.853341,48.9880123 57.5771986,48.9880123 L6.50551419,48.9880123 C6.22937181,48.9880123 6.00551419,48.7641546 6.00551419,48.4880123 L6.00551419,43.9700306 C6.00551419,41.7608916 7.79637519,39.9700306 10.0055142,39.9700306 L54.0771986,39.9700306 C56.2863376,39.9700306 58.0771986,41.7608916 58.0771986,43.9700306 Z",
    id: "Combined-Shape",
    fillOpacity: 0.2,
    fill: "url(#linearGradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7320364,-0.299819227 C37.9154141,-0.36543161 39.9232352,0.450811585 41.4102841,1.82897284 C42.897333,3.20713409 43.8636097,5.1472134 43.9638987,7.32927324 L43.9638987,7.32927324 L44.7521098,24.4789558 L53.1978091,23.2787895 L31.0846648,61.4139647 L29.2878507,12.9473098 L24.7809839,0.0292693508 Z",
    id: "Rectangle",
    stroke: "url(#linearGradient-4)",
    strokeWidth: 4,
    transform: "translate(39.493902, 32.905445) rotate(60.000000) translate(-39.493902, -32.905445) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1026411,7.5115108 L71.3186191,7.51300589 C71.5947615,7.51308504 71.8447294,7.62508551 72.0256419,7.80610178 C72.2041915,7.98475375 72.3154778,8.23063043 72.3182783,8.50248564 L72.3182783,8.50248564 L72.2432741,13.5077373 L65.0271706,13.5056689 L65.1024674,8.49648072 C65.1065747,8.22324377 65.2199842,7.97696213 65.4006839,7.7990093 C65.5813835,7.62105648 65.8293733,7.51143247 66.1026411,7.5115108 L66.1026411,7.5115108 Z",
    id: "Rectangle",
    stroke: "#AD6C97",
    strokeWidth: 4,
    fill: "#FFFFFF",
    transform: "translate(68.680322, 10.509483) rotate(56.000000) translate(-68.680322, -10.509483) "
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPxHandbrakeIllustration);
export default __webpack_public_path__ + "static/media/px-handbrake-illustration.26b85d3e89e9d85f8a0e83f9d95c685d.svg";
export { ForwardRef as ReactComponent };